import { KnowledgeTypes } from '../actions/knowledgeAction';

const defaultState = {
  topFeatures: [],
  totalTopFeatures: 0,
  dataIncident: [],
  dataRequest: [],
  totalIncidentItems: 0,
  totalRequestItems: 0,
  isLoading: false,
};

const knowledgeReducer = (state = defaultState, action: any) => {
  const { dataIncident, dataRequest, dataTopFeatures } = action;

  switch (action.type) {
    case KnowledgeTypes.GET_KNOWLEDGE:
      return {
        ...state,
        topFeatures: [],
        totalTopFeatures: 0,
        isLoading: false,
      };
    case KnowledgeTypes.GET_KNOWLEDGE_SUCCESS:
      return {
        ...state,
        topFeatures: dataTopFeatures?.data || [],
        totalTopFeatures: dataTopFeatures?.totalCount || 0,
        isLoading: true,
      };
    case KnowledgeTypes.GET_KNOWLEDGE_FAIL:
      return {
        ...state,
        isLoading: true,
      };
    case KnowledgeTypes.GET_MORE_KNOWLEDGE_SUCCESS:
      return {
        ...state,
        topFeatures: [...state.topFeatures, ...dataTopFeatures?.data],
        totalTopFeatures: dataTopFeatures?.totalCount || 0,
      };
    case KnowledgeTypes.GET_INCIDENT_TICKET_LIST_SUCCESS:
      return {
        ...state,
        dataIncident: dataIncident?.items || [],
        totalIncidentItems: dataIncident?.totalItems || 0,
      };
    case KnowledgeTypes.GET_REQUEST_TICKET_LIST_SUCCESS:
      return {
        ...state,
        dataRequest: dataRequest?.items || [],
        totalRequestItems: dataRequest?.totalItems || 0,
      };
  }

  return state;
};

export default knowledgeReducer;
